export function EurIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1490_9367)">
        <path
          d="M12.5059 24C19.1333 24 24.5059 18.6274 24.5059 12C24.5059 5.37258 19.1333 0 12.5059 0C5.87844 0 0.505859 5.37258 0.505859 12C0.505859 18.6274 5.87844 24 12.5059 24Z"
          fill="#0052B4"
        />
        <path
          d="M12.5052 4.69531L12.8937 5.89105H14.1509L13.1338 6.63003L13.5223 7.82577L12.5052 7.08673L11.488 7.82577L11.8765 6.63003L10.8594 5.89105H12.1166L12.5052 4.69531Z"
          fill="#FFDA44"
        />
        <path
          d="M7.33963 6.83479L8.45994 7.40554L9.34892 6.5166L9.15219 7.75832L10.2725 8.32912L9.03069 8.5258L8.834 9.76762L8.2632 8.64735L7.02148 8.84409L7.91047 7.9551L7.33963 6.83479Z"
          fill="#FFDA44"
        />
        <path
          d="M5.20117 11.9993L6.39691 11.6107V10.3535L7.13584 11.3707L8.33162 10.9822L7.59255 11.9993L8.33162 13.0164L7.13584 12.6279L6.39691 13.6451V12.3878L5.20117 11.9993Z"
          fill="#FFDA44"
        />
        <path
          d="M7.34158 17.1642L7.91238 16.0439L7.02344 15.1549L8.2652 15.3517L8.83591 14.2314L9.03264 15.4732L10.2744 15.6699L9.15423 16.2407L9.35088 17.4824L8.46189 16.5934L7.34158 17.1642Z"
          fill="#FFDA44"
        />
        <path
          d="M12.5052 19.3042L12.1166 18.1085H10.8594L11.8766 17.3695L11.488 16.1738L12.5052 16.9128L13.5223 16.1738L13.1338 17.3695L14.1509 18.1085H12.8937L12.5052 19.3042Z"
          fill="#FFDA44"
        />
        <path
          d="M17.671 17.1642L16.5507 16.5935L15.6617 17.4825L15.8585 16.2406L14.7383 15.6699L15.98 15.4732L16.1767 14.2314L16.7474 15.3517L17.9892 15.1549L17.1002 16.044L17.671 17.1642Z"
          fill="#FFDA44"
        />
        <path
          d="M19.81 11.9993L18.6143 12.3878V13.6451L17.8753 12.6279L16.6797 13.0164L17.4187 11.9993L16.6797 10.9822L17.8754 11.3707L18.6143 10.3535V11.6108L19.81 11.9993Z"
          fill="#FFDA44"
        />
        <path
          d="M17.671 6.83474L17.1002 7.95506L17.9892 8.84404L16.7474 8.64726L16.1767 9.76752L15.98 8.52576L14.7383 8.32902L15.8585 7.75827L15.6617 6.5166L16.5508 7.40554L17.671 6.83474Z"
          fill="#FFDA44"
        />
      </g>
      <defs>
        <clipPath id="clip0_1490_9367">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.505859)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
